// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3wmtg","boxTitle":"Qualiphy_boxTitle__21OMH","box":"Qualiphy_box__iUsT2","toggleWrap":"Qualiphy_toggleWrap__QFaom"};